export default {
    menu: {
        places: 'Reiseziele',
    },

    menuTooltips: {
        places: 'Reiseziele anlegen und verwalten. Die Adressen finden z.B in Veranstaltungen verwendung.',
    },
}